import { w } from 'windstitch';

export const ContentBox = w.footer(
  'flex flex-col items-center text-center w-full bg-[var(--azul-escuro)] text-white p-8 md:p-12 md:pb-8 rounded-t-xl rounded-b-none'
);


export const CardsBox = w.div(
  'w-full mb-16 pt-8 mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-sm text-left',
);

export const Card = w.div(
  'text-lg flex flex-col',
);

export const Btn = w.button(
  'hover:text-[var(--azul)] text-lg border text-left',
);


export const TitleCard = w.h3(
  'font-semibold border-b border-white/40 mb-2'
)

export const SubText = w.p(
  'text-xl mt-4 mb-20'
)

export const ImageBox = w.div(
  'flex items-center justify-center'
)

export const Reserved = w.div(
  'w-full text-center pt-8  border-t text-sm',
);
